<template>
	<div class="container">
    <div v-title>申请售后</div>
		<div class="img-box" v-for="item1 in imgList" v-if="imgList.length>0">
			<img :src="item1" class="show-img" />
		</div>
		<div class="content">
			<a v-for="item in menuList"  :href="item.url" :key="item.url">
				<p >
					{{item.title}}
					<img src="https://misc.reflower.com.cn/images/gou.png" class="go-othor" />
				</p>
			</a>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				menuList : [],
				imgList : []
			}
		},
		created(){
			this.getInfo()
		},
		methods:{
			getInfo(){
				this.http({
					url: this.servicePage,
					method: 'get',
				}).then(res =>{
					if(res.data.code == 2000){
						let data = res.data.data;
						this.imgList.push(data.imgurl);
						this.menuList = data.contents
					}else{
						this.popUp(res.data.msg)
					}
				})
			},
			popUp: function(content) {
				layer.open({
					content: content,
					skin: 'msg',
					time: 2 //2秒后自动关闭
				});
			},
		}
	}
</script>

<style scoped="scoped">
	.container{
		min-height: 100vh;
		background-color: #FFFFFF;
		padding-bottom: 0.533333rem;
	}
	.img-box .show-img{
		display: block;
		width: 100%;
		height: 5rem;
	}
	a{
		text-decoration:none;
		color: #333333;
	}
	.content{
		padding: 0 0.4rem;
	}
	.content p{
		border-bottom: 1px solid #DDDDDD;
		height: 1.2rem;
		line-height: 1.2rem;
		font-size: 0.4rem;
		color: #333333;
		text-align: left;
		position: relative;
	}
	.content p .go-othor{
		display: inline-block;
		width: 0.186666rem;
		height: 0.32rem;
		position: absolute;
		right: 0;
		top: 0.44rem;
	}
</style>


// WEBPACK FOOTER //
// src/path/servicePage/service.vue